import styles from '@/assets/styles/pages/competition/competition.module.scss';
import React, { useRef } from 'react';
import FashButton from '@/components/FashButton';
import { MimaText, MimaButton } from '@/components';
import { useInView } from 'framer-motion';
import Link from 'next/link';
import constant from '@/utils/constant';
import { useRouter } from 'next/navigation';
import { isDateWithinRange } from '@/utils/utils';

interface CompetitionsProps {
  competitionList: any;
}

const Steps: React.FC<CompetitionsProps> = ({ competitionList }) => {
  const currentCompetition = competitionList?.filter((item: any) => item?.status === 'ACTIVE').map((competition: any) => competition);
  const startDate = currentCompetition?.[0]?.registrationStartDate;
  const endDate = currentCompetition?.[0]?.registrationEndDate;

  const isDisabled = !isDateWithinRange(startDate, endDate);
  const router = useRouter();
  const switchToSignup = () => {
    router.push(constant.Routes.Register);
  };

  const steps = [
    {
      step: 1,
      title: 'Follow Us',
      details: 'Follow Fash Creatives on any of our social media handles.(See website footer for our social media handles)',
    },
    {
      step: 2,
      title: 'Like and Share Post',
      details: 'Like and share our post relating to the competition on any of our social media handle.',
    },
    {
      step: 3,
      title: 'Register',
      details: 'Click on the “REGISTER” button to enter the competition.',
    },
  ];

  return (
    <section className={styles.steps}>
      <div className={styles.container}>
        <MimaText variant="h2" align="center" className={styles.titleText}>
          Our <span>3-Step</span> Process
        </MimaText>

        <div className={styles.set}>
          <div className={styles.stepsCard}>
            <div className={styles.stepsCardTitle}>
              <MimaText variant="h4">How To Enter Competition</MimaText>
            </div>
            <div className={styles.stepsList}>
              {steps.map((step, index) => (
                <div className={index < steps.length - 1 ? styles.step : styles.lastStep} key={index}>
                  <div className={styles.title}>
                    <div className={styles.icon}></div>
                    <MimaText variant="bodyBold" fontWeight={500} color="var(--color-dark2)">
                      {step.title}
                    </MimaText>
                  </div>
                  <div className={styles.details}>
                    <div className={styles.line}>
                      <hr />
                    </div>
                    <MimaText variant="small" color="var(--color-dark-3)" mt={0.8} mb={2.8}>
                      {step.details}{' '}
                      {step.title === 'Like and Share Post' && (
                        <div style={{ display: 'flex', gap: '2rem', paddingTop: '1rem' }}>
                          {currentCompetition?.[0]?.twitterLink ? (
                            <div>
                              <Link href={currentCompetition?.[0]?.twitterLink} target="_blank" rel="noopener noreferrer">
                                <MimaButton variant="outlined" title="Visit Twitter Post" height={3} />
                              </Link>
                            </div>
                          ) : (
                            ''
                          )}
                          {currentCompetition?.[0]?.instagramLink ? (
                            <Link href={currentCompetition?.[0]?.instagramLink} target="_blank" rel="noopener noreferrer">
                              {' '}
                              <MimaButton variant="outlined" title="Visit Instagram Post" height={3} />
                            </Link>
                          ) : (
                            ''
                          )}
                        </div>
                      )}
                    </MimaText>
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.buttonSet}>
              <Link href={`${constant.Routes.Competition}#learnMore`}>
                <FashButton title="Learn More" color="var(--color-dark)" />
              </Link>
              {currentCompetition?.[0]?.stage === 'REG' && (
                <MimaButton variant="outlined" title="Register" onClick={switchToSignup} width={18} height={5.8} />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Steps;
